import { createSlice } from "@reduxjs/toolkit";
import { resolveApiMessage } from "../../helpers/apiMessage";
import { createTableQr, deleteTableQr, getTableQrs, resolveTableQr, verifyTableQr } from "./thunk";

const getMsg = (payload: any) => resolveApiMessage(payload);
const getData = (payload: any) => payload?.data ?? payload;

export const initialState = {
    items: [] as any[],
    loading: false,
    submitting: false,
    error: null as string | null,
    resolved: null as any,
    resolving: false,
    resolveError: null as string | null,
};

const slice = createSlice({
    name: "TableQrs",
    initialState,
    reducers: {
        clearResolvedQr: (state) => {
            state.resolved = null;
            state.resolveError = null;
            state.resolving = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTableQrs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTableQrs.fulfilled, (state, action) => {
                state.loading = false;
                const data = getData(action.payload);
                state.items = Array.isArray(data) ? data : [];
            })
            .addCase(getTableQrs.rejected, (state, action: any) => {
                state.loading = false;
                state.items = [];
                state.error = getMsg(action.payload);
            })
            .addCase(createTableQr.pending, (state) => {
                state.submitting = true;
                state.error = null;
            })
            .addCase(createTableQr.fulfilled, (state, action) => {
                state.submitting = false;
                const item = getData(action.payload);
                if (item && typeof item === "object") {
                    state.items = [item, ...state.items.filter((x: any) => String(x?.id) !== String(item.id))];
                }
            })
            .addCase(createTableQr.rejected, (state, action: any) => {
                state.submitting = false;
                state.error = getMsg(action.payload);
            })
            .addCase(deleteTableQr.pending, (state) => {
                state.submitting = true;
                state.error = null;
            })
            .addCase(deleteTableQr.fulfilled, (state, action: any) => {
                state.submitting = false;
                state.items = state.items.filter((x: any) => String(x?.id) !== String(action.payload?.id));
            })
            .addCase(deleteTableQr.rejected, (state, action: any) => {
                state.submitting = false;
                state.error = getMsg(action.payload);
            })
            .addCase(resolveTableQr.pending, (state) => {
                state.resolving = true;
                state.resolveError = null;
                state.resolved = null;
            })
            .addCase(resolveTableQr.fulfilled, (state, action) => {
                state.resolving = false;
                state.resolved = getData(action.payload);
            })
            .addCase(resolveTableQr.rejected, (state, action: any) => {
                state.resolving = false;
                state.resolveError = getMsg(action.payload);
                state.resolved = null;
            })
            .addCase(verifyTableQr.pending, (state) => {
                state.resolving = true;
                state.resolveError = null;
                state.resolved = null;
            })
            .addCase(verifyTableQr.fulfilled, (state, action) => {
                state.resolving = false;
                state.resolved = getData(action.payload);
            })
            .addCase(verifyTableQr.rejected, (state, action: any) => {
                state.resolving = false;
                state.resolveError = getMsg(action.payload);
                state.resolved = null;
            });
    },
});

export const { clearResolvedQr } = slice.actions;
export default slice.reducer;
